<template>
  <div>
    <v-tabs v-model="tab" active-class="tab-active" background-color="transparent">
      <v-tab class="tab-default" :key="1"> Học viên</v-tab>
      <v-tab class="tab-default" :key="2"> Giáo viên </v-tab>
      <!-- <v-tab class="tab-default" :key="3"> Điểm số </v-tab> -->
      <v-tab class="tab-default" :key="4"> Chuyên cần </v-tab>
    </v-tabs>

    <v-card outlined :flat="$vuetify.breakpoint.smAndDown">
      <v-tabs-items v-model="tab">
        <v-tab-item :key="1">
          <v-card>
            <div class="d-flex justify-end align-center">
              <v-btn
                v-if="$vuetify.breakpoint.mdAndUp"
                class="mt-4 mr-4"
                outlined
                color="success"
                @click="exportExcel('STUDENT_TABLE')"
              >
                <v-icon left>mdi-file-excel</v-icon> Xuất Excel
              </v-btn>
              <v-btn
                class="mt-4 mr-4"
                v-if="$auth.policies['add-student-extraClass']"
                depressed
                dark
                color="#0D47A1"
                @click.stop="createState = !createState"
              >
                <v-icon left>add</v-icon>Thêm Học viên
              </v-btn>
            </div>
            <StudentTable disableSort mobile-breakpoint="0" ref="studentTable" />
          </v-card>
        </v-tab-item>
        <v-tab-item :key="2">
          <div class="ma-6">
            <div class="d-flex justify-space-between align-center">
              <h3 class="mr-4">Giáo viên giảng dạy</h3>
              <v-btn
                v-if="$auth.policies['add-new-teaching']"
                class="ml-4"
                depressed
                outlined
                color="primary"
                @click="isOpenTeachingDialog = !isOpenTeachingDialog"
                :block="$vuetify.breakpoint.smAndDown"
              >
                <v-icon left>add</v-icon>
                Phân công giáo viên
              </v-btn>
            </div>
            <div v-if="teachers.length">
              <CardTeacherName v-for="teacher in teachers" :teacher="teacher" :key="teacher.id" link />
            </div>
            <div v-else class="red--text">Chưa phân công giáo viên</div>
          </div>
        </v-tab-item>
        <v-tab-item :key="3">
          <MarksView />
        </v-tab-item>
        <v-tab-item :key="4">
          <ClassAttendance />
        </v-tab-item>
      </v-tabs-items>
    </v-card>
    <ExtraClassAddStudentDialog :state="createState" />
    <TeachingNewDialog
      :showTeacher="true"
      :showAssistant="true"
      :state="isOpenTeachingDialog"
      @done="teachingRefresh"
    />
  </div>
</template>

<script>
import StudentTable from '@/modules/class/student/StudentTable.vue'
import ParentDataTable from '@/modules/class/ParentDataTable.vue'
import CardOwnClassTeacherInfo from '@/components/basic/card/CardOwnClassTeacherInfo.vue'
import ExtraClassAddStudentDialog from '@/modules/class/ExtraClassAddStudentDialog.vue'
import { mapGetters, mapState, mapActions } from 'vuex'
import utils from '@/plugins/utils'
import CardTeacherName from '@/components/basic/card/CardTeacherName.vue'
import ClassAttendance from '../class-detail/ClassAttendance.vue'
import MarksView from '@/modules/mark/MarksView.vue'
import TeachingNewDialog from '@/modules/teacher/TeachingNewDialog'
// import StudyGroupDialog from '@/modules/class/student/StudyGroupDialog.vue'

export default {
  data() {
    return {
      tab: null,
      showStudyGroupDialog: false,
      createState: false,
      isOpenTeachingDialog: false,
    }
  },
  components: {
    ExtraClassAddStudentDialog,
    CardOwnClassTeacherInfo,
    StudentTable,
    ParentDataTable,
    CardTeacherName,
    ClassAttendance,
    MarksView,
    TeachingNewDialog,
    // StudyGroupDialog
  },
  methods: {
    ...mapActions('classDetail', ['initClass']),
    async teachingRefresh() {
      await this.initClass({ id: this.$route.params.id })
    },
    exportExcel(tableName) {
      this.$loading.active = true
      const filters = this.$options.filters
      const students = JSON.parse(JSON.stringify(this.students.filter((s) => s.status === 'active')))
      let excelHeader, fileName, data
      switch (tableName) {
        case 'STUDENT_TABLE':
          // eslint-disable-next-line no-case-declarations
          let studentHeaders = [...this.$refs.studentTable.headers]
          studentHeaders.shift()
          studentHeaders.splice(1, 0, {
            text: 'Mã số',
            value: 'code',
          })
          excelHeader = studentHeaders.map(({ text, value }) => ({ text, value }))
          data = students.map((item) => {
            item.code = filters.getStudentCode(item.code)
            item.status = filters.status(item.status)
            item.dob = filters.ddmmyyyy(item.dob)
            item.gender = filters.gender(item.gender)
            return item
          })
          fileName = `DanhSachHocSinh_${this.classData.title}`
          break
        case 'PARENT_TABLE':
          // eslint-disable-next-line no-case-declarations
          let parentHeaders = [...this.$refs.parentDataTable.headers]
          parentHeaders.shift()
          parentHeaders.splice(1, 0, {
            text: 'Mã số',
            value: 'code',
          })
          excelHeader = parentHeaders.map(({ text, value }) => ({ text, value }))
          data = students.map((item) => {
            item.code = filters.getStudentCode(item.code)
            item.dob = filters.ddmmyyyy(item.dob)
            return item
          })
          fileName = `DanhSachPhuHuynh_${this.classData.title}`
          break
        case 'TEACHER_TABLE':
          excelHeader = this.$refs.teacherTable.headers.map(({ text, value }) => ({ text, value }))
          data = this.teachings
          fileName = `GiaoVienBoMon_${this.classData.title}`
          break
      }
      utils.exportExcel(data, excelHeader, fileName)
      this.$loading.active = false
    },
  },
  computed: {
    ...mapGetters('classDetail', ['students', 'classData']),
    ...mapState('classDetail', ['teachings']),
    teachers() {
      const teachings = this.teachings
      if (Array.isArray(teachings) && teachings.length) return teachings[0].teachers
      return null
    },
  },
}
</script>
